export enum ProjectType {
    NewConstruction = 'NEW_BUILDING',
    Renovation = 'MODERNISATION'
}
